module.exports = __webpack_public_path__ + "assets/2bd8b240b6efe7ea4ec60eb962359e74.png";